import React, { useEffect, useState } from "react";
import { colors, fonts } from "../Styles";
import { useAppSelector } from "../Store";
import { getFarmSettingsState } from "../Services/Agrisys_GqlDataCaller/UserCalls/dataCalls";

const Clock = () => {
  const [dateTime, setDateTime] = useState(new Date());
  const [intervalId, setIntervalId] = useState<NodeJS.Timer | null>(null);
  const farmSettings = useAppSelector(getFarmSettingsState)

  function stopClock() {
    if (intervalId) clearInterval(intervalId);
  }

  function startClock() {
    stopClock();
    const newIntervalId = setInterval(() => {
      setDateTime(new Date());
    }, 10000);
    setIntervalId(newIntervalId);
  }

  useEffect(() => {
    startClock();
    return () => stopClock();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div style={{ color: colors.greyLightTertiary, ...fonts.header,  ...fonts.textShadow, ...fonts.fontSize4 }}>
      <p>
        {dateTime.toLocaleString('default', {
          year: 'numeric',
          month: 'numeric',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          hour12: false, // 24-hour format
          timeZone: farmSettings?.time_zone_label ?? undefined
        }).replace(/,/g, '')}
      </p>
    </div>
  );
};

export default Clock;